define('formkit/view/block/revisions.menu.view',['require','exports','module','underscore','marionette','uikit/uikit','moment'],function(require, exports, module) {
  var _      = require('underscore');
  var Mn     = require('marionette');
  var UIKit  = require('uikit/uikit');
  var moment = require('moment');

  var RestoreRevisionBehavior = Mn.Behavior.extend({
    defaults: {
      form: null
    },

    initialize: function() {
      this.listenToOnce(this.view, 'before:render', this.setupVisibilityHandler);
    },

    setupVisibilityHandler: function() {
      this.listenTo(this.view, 'change:active', function() {
        this.setViewVisibility();
      });
      this.setViewVisibility();
    },

    setViewVisibility: function() {
      var model = this.view.model;
      if (model) {
        this.view.visible = this.view.active && !!this.view.model.get('publishedDate')
      }
      else {
        this.view.visible = this.view.active;
      }
    },

    triggers: {
    	'click': {
    		event: 'press',
    		stopPropagation: true
    	}
    },

    onPress: function() {
      var form = this.getOption('form') || this.view.form;
      form.trigger('revert', this.view.model);
    },
  });


  var RevisionItemView = UIKit.ItemView.extend({
    template: function() {
      return  '<strong>Revision </strong><ui name="revisionNumberView" />' +
              '<div class="muted"><ui name="publishedDateTextView"/> <ui name="publishedDateView" /></div>' +
              '<div style="margin-top:0.4em"><ui name="restoreRevisionButtonView" /></div>'
    },

    options: {
      form: null,
      active: false
    },

    internalViewBindings: {
      restoreRevisionButtonView: {
        active: 'active'
      }
    },

    behaviors: {
      ActiveRowBehavior: {
        behaviorClass: Mn.Behavior.extend({
          initialize: function() {
            this.listenToOnce(this.view, 'render', function() {
              this.listenTo(this.view.rowView, 'change:active', function(rowView, newValue, oldValue) {
                this.view.active = newValue;
              });
              this.view.active = this.view.rowView.active;
            })
          }
        })
      }
    },

    internalViewOptions: {
      revisionNumberView: function() {
        return {
          type: UIKit.Text,
          tagName: 'strong',
          model: this.model,
          bindings: {
            text: 'number'
          }
        }
      },
      publishedDateTextView: function() {
        return {
          type: UIKit.Text,
          model: this.model,
          bindings: {
            text: 'publishedDate'
          },
          formatter: function(val) {
            if (!val) {
              return 'In-Draft Revision'
            }
            else {
              return 'Published on '
            }
          }
        }
      },
      publishedDateView: function() {
        return {
          type: UIKit.Text,
          model: this.model,
          bindings: {
            text: 'publishedDate'
          },
          formatter: function(val) {
            var result = moment(val).format('L LT');
            if (result == "Invalid date") {
              return '';
            }
            else {
              return result;
            }
          }
        }
      },
      restoreRevisionButtonView: function() {
        return {
          type: UIKit.Button,
          model: this.model,
          text: 'Restore this revision',
          inline: true,
          color: 'blue',
          behaviors: {
            RestoreRevisionBehavior: {
              form: this.getOption('form'),
              parentView: this,
              behaviorClass: RestoreRevisionBehavior
            }
          }
        }
      }
    }
  });

  var RevisionsMenuView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="tableView" /><ui name="paginationView" />'
    },

    options: {
      form: null,
      value: null
    },

    internalViewBindings: {
      tableView: {
        value: 'value'
      }
    },

    internalViewOptions: {
      tableView:  function() {
        return _.extend({}, {
          type: UIKit.Table,
          padded: true,
          color: 'secondary',
          collection: this.collection,
          selectable: true,
          selection: 'single',
          columns: [{
            childView: RevisionItemView,
            childViewOptions: {
              form: this.form
            },
            text: 'Revisions'
          }]
        },
        this.getOption('table'))
      },
      paginationView: function() {
        return _.extend({}, {
          model: this.collection.paginate
        },
        this.getOption('pagination'));
      }
    },

    initialize: function() {
      UIKit.ItemView.prototype.initialize.apply(this, arguments);

      this.listenTo(this.form, 'revert', function(revision) {
        this.trigger('revert', revision);
      });

    }
  });
  module.exports = RevisionsMenuView;
});

